import { SET_SORT } from "../actionTypes.js";
import { SORT_COLUMNS } from "../../constants.js";

const initialState = { column: SORT_COLUMNS.DATE, asc: false };

const sorter = (state = initialState, action) => {
  switch (action.type) {
    case SET_SORT: {
      if(action.payload.column==state.column) //gleiche spalte, nur richtig drehen
        return {...state, asc:!state.asc }
      else
        return {...state, column:action.payload.column }
    }
    default: {
      return state;
    }
  }
};

export default sorter;
